export const CKEdiorConfig = [
    'undo',
    'redo',
    '|',
    'heading',
    '|',
    'fontfamily',
    'fontsize',
    'fontColor',
    'fontBackgroundColor',
    '|',
    'bold',
    'italic',
    'strikethrough',
    'subscript',
    'superscript',
    'code',
    '|',
    'link',
    'blockQuote',
    'codeBlock',
    '|',
    'alignment',
    '|',
    'bulletedList',
    'numberedList',
    'todoList',
];
